import { useEffect, useState } from "react";

import { useAppState } from "../../context/StateContext";
import { useSecretManager } from "../../hooks/useSecretManager";
import useFCMToken from "../../hooks/useFCMToken";
import useNotificationHandler from "../../hooks/useNotificationHandler";
import { FirebaseSecretData, initializeFirebase } from "../../services/firebase.service";
import env from "../../util/env";
import { parseNestedJson } from "Util/parseNestedJson";

export const FCMInitializer = () => {
  const { currentUser } = useAppState();
  const firebaseSecretId = env.FIREBASE_SECRET || env.SECRET_ID;
  const { secret } = useSecretManager(firebaseSecretId);
  const [isFirebaseInitialized, setIsFirebaseInitialized] = useState(false);

  const isUserLoggedIn = !!(currentUser && currentUser.id);

  useEffect(() => {
    if (!isUserLoggedIn) {
      return;
    }

    const init = async () => {
      console.log("secret", !!secret);
      console.log("isFirebaseInitialized", isFirebaseInitialized);
      if (secret && !isFirebaseInitialized) {
        let firebaseSecretData: FirebaseSecretData = parseNestedJson(secret.FIREBASE_CONFIG_CLIENT ?? '{}')

        if (
          !firebaseSecretData.apiKey ||
          !firebaseSecretData.authDomain ||
          !firebaseSecretData.projectId ||
          !firebaseSecretData.storageBucket ||
          !firebaseSecretData.messagingSenderId ||
          !firebaseSecretData.appId
        ) {
          console.warn("Firebase configuration is incomplete in Secret Manager");
          return null;
        }

        const messaging = await initializeFirebase(firebaseSecretData);
        if (messaging) {
          setIsFirebaseInitialized(true);
          console.log("Firebase Messaging initialized successfully for user:", currentUser?.id);

          if ("serviceWorker" in navigator) {
            navigator.serviceWorker.ready.then((registration) => {
              registration.active?.postMessage({
                type: "FIREBASE_CONFIG",
                config: firebaseSecretData,
              });
            });
          }
        }
      }
    };

    init();
  }, [secret, isFirebaseInitialized, isUserLoggedIn, currentUser?.id]);

  const { permission, requestPermission } = useFCMToken(
    secret,
    currentUser?.id ?? -1,
    isUserLoggedIn && isFirebaseInitialized
  );

  useNotificationHandler({
    enabled: isUserLoggedIn && isFirebaseInitialized && permission === "granted",
    onNotificationClick: (data) => {
      console.log("Notification clicked with data:", data);
      if (data?.url) {
        window.location.href = data.url;
      }
    },
    showToast: true,
  });

  useEffect(() => {
    if (isUserLoggedIn && isFirebaseInitialized && permission === "default") {
      requestPermission();
    }
  }, [isUserLoggedIn, isFirebaseInitialized, permission, requestPermission]);

  return null;
};

export default FCMInitializer;
